import React from 'react';
import DentalServicePage from './DentalServicePage';

const RootCanalTreatment = () => {
    // Defined content for Root Canal Treatment
    const serviceName = 'Root Canal Treatment';
    const serviceTagline = 'Advanced, pain-free root canal therapy at Wisdom Dental Clinic';

    const whatIsContent = [
        'Root canal treatment is a dental procedure that addresses infection and damage to the inner pulp of a tooth. This specialized treatment preserves your natural tooth while eliminating pain and infection.',
        'During the procedure, your dentist removes the infected or damaged pulp, thoroughly cleans the inside of the tooth, and then fills and seals it to prevent future infection. Despite its reputation, modern root canal therapy is virtually painless and can be completed in just one or two appointments.',
    ];

    const whenRequiredContent = {
        paragraphs: ['Early detection and treatment can prevent the need for tooth extraction and more extensive procedures.'],
        listIntro: 'You may need a root canal if you experience:',
        list: [
            'Severe toothache or pain when chewing',
            'Prolonged sensitivity to hot or cold temperatures',
            'Darkening or discoloration of the tooth',
            'Swelling and tenderness in nearby gums',
            'Persistent or recurring pimple on the gums',
            'Deep decay or a cracked tooth that has reached the pulp',
        ],
        closing:
            "If you're experiencing any of these symptoms, it's important to schedule an evaluation as soon as possible to prevent the infection from spreading.",
    };

    const howDoneContent = {
        paragraphs: [
            'At Wisdom Dental Clinic, we utilize advanced technology and techniques to make your root canal treatment comfortable and efficient.',
        ],
        listIntro: 'Our clinic features:',
        list: [
            'Digital imaging for precise diagnostics',
            'Advanced rotary endodontic instruments',
            'Powerful local anesthetics for complete comfort',
            'Dental operating microscopes for enhanced visibility',
            'Advanced sterilization protocols',
            'Single-visit options for suitable cases',
        ],
        closing:
            'Our skilled endodontists have years of specialized training and experience, ensuring the highest quality care for every patient.',
    };

    const benefitsContent = [
        {
            title: 'Pain Relief',
            description: 'Eliminates the source of tooth pain and infection',
        },
        {
            title: 'Preserve Natural Tooth',
            description: 'Saves your natural tooth and avoids the need for extraction',
        },
        {
            title: 'Improved Aesthetics',
            description: 'Maintains your natural smile and facial structure',
        },
        {
            title: 'Efficient Chewing',
            description: 'Restores normal biting force and sensation',
        },
        {
            title: 'Prevents Spread',
            description: 'Stops infection from spreading to other teeth or parts of your body',
        },
        {
            title: 'Cost-Effective',
            description: 'More affordable than extraction and replacement with artificial teeth',
        },
    ];

    const procedureSteps = [
        {
            title: 'Examination and X-ray',
            description: 'Your dentist will examine the tooth and take X-rays to assess the damage and plan the treatment.',
        },
        {
            title: 'Anesthesia',
            description: 'Local anesthesia is administered to ensure you feel no pain during the procedure.',
        },
        {
            title: 'Isolation',
            description: 'A dental dam is placed to keep the area clean and free from saliva during treatment.',
        },
        {
            title: 'Access and Cleaning',
            description:
                'A small opening is made in the crown of the tooth to access the pulp chamber and root canals, which are then cleaned thoroughly.',
        },
        {
            title: 'Shaping and Filling',
            description: 'The canals are shaped and filled with a biocompatible material called gutta-percha.',
        },
        {
            title: 'Sealing and Restoration',
            description:
                'The access opening is sealed with a temporary filling. A crown or other restoration is typically placed in a follow-up appointment.',
        },
    ];

    const seoData = {
        title: 'Best Root Canal Treatment in Sector 23, Palam Vihar, Gurgaon',
        description:
            'Looking for the Best Root Canal Treatment in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers painless RCT. Call now!',
        keywords:
            'Root Canal Treatment Near Me, Root Canal Treatment Gurgaon, Root Canal Treatment Sector 23 Gurgaon, Root Canal Treatment Sector 23 Gurgaon, Root Canal Treatment Palam Vihar Gurgaon',
        canonical: 'https://wisdomdentalclinics.in/rct',
        ogTitle: 'Best Root Canal Treatment in Sector 23, Palam Vihar, Gurgaon',
        ogDescription:
            'Looking for the Best Root Canal Treatment in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers painless RCT. Call now!',
        twitterTitle: 'Best Root Canal Treatment in Sector 23, Palam Vihar, Gurgaon',
        twitterDescription:
            'Looking for the Best Root Canal Treatment in Sector 23, Palam Vihar, Gurgaon? Wisdom Dental Clinic offers painless RCT. Call now!',
        h1Text: 'Root Canal Treatment in Sector 23 Palam Vihar Gurgaon',
    };

    return (
        <DentalServicePage
            serviceName={serviceName}
            serviceTagline={serviceTagline}
            whatIsContent={whatIsContent}
            whenRequiredContent={whenRequiredContent}
            howDoneContent={howDoneContent}
            benefitsContent={benefitsContent}
            procedureSteps={procedureSteps}
            seoData={seoData}
        />
    );
};

export default RootCanalTreatment;
